/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.payment.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.payment = {};
proto.witbooking.backoffice.payment.v1 = require('./payment_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest,
 *   !proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse>}
 */
const methodDescriptor_CreditCardTypeAPI_GetCreditCards = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/GetCreditCards',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest,
  proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse,
  /**
   * @param {!proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest,
 *   !proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse>}
 */
const methodInfo_CreditCardTypeAPI_GetCreditCards = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse,
  /**
   * @param {!proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIClient.prototype.getCreditCards =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/GetCreditCards',
      request,
      metadata || {},
      methodDescriptor_CreditCardTypeAPI_GetCreditCards,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.payment.v1.GetCreditCardsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.payment.v1.GetCreditCardsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIPromiseClient.prototype.getCreditCards =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/GetCreditCards',
      request,
      metadata || {},
      methodDescriptor_CreditCardTypeAPI_GetCreditCards);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest,
 *   !proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse>}
 */
const methodDescriptor_CreditCardTypeAPI_EnableCreditCard = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/EnableCreditCard',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest,
  proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse,
  /**
   * @param {!proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest,
 *   !proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse>}
 */
const methodInfo_CreditCardTypeAPI_EnableCreditCard = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse,
  /**
   * @param {!proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIClient.prototype.enableCreditCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/EnableCreditCard',
      request,
      metadata || {},
      methodDescriptor_CreditCardTypeAPI_EnableCreditCard,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.payment.v1.EnableCreditCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.payment.v1.EnableCreditCardResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.payment.v1.CreditCardTypeAPIPromiseClient.prototype.enableCreditCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.payment.v1.CreditCardTypeAPI/EnableCreditCard',
      request,
      metadata || {},
      methodDescriptor_CreditCardTypeAPI_EnableCreditCard);
};


module.exports = proto.witbooking.backoffice.payment.v1;

